import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const style = document.createElement('style');
style.textContent = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f5f7fa; font-family: 'Inter', 'Segoe UI', sans-serif; color: #1a1f36; }
  input, select, button, textarea { font-family: inherit; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #f1f5f9; }
  ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
  @keyframes spin { to { transform: rotate(360deg) } }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
  
/* Main Container */
.new-table-box{
    background:#fff;
}

/* Table */
.new-table-box table{
    width:100%;
    border-collapse:collapse;
}

/* Header */
.new-table-box th{
    background:#f4f5f6;
    color:#5f6368;
    font-size:13px;
    text-align:left;
    padding:12px;
}

/* Table Cell */
.new-table-box td{
    padding:12px;
    border-top:1px solid #e0e0e0;
    font-size:14px;
}

/* Right aligned numbers */
.new-table-box td.num{
    text-align:right;
}

/* Section heading */
.new-table-box .section{
    font-weight:bold;
    background:#e9e7e7;
}

.new-table-box .section td{
    padding:14px 12px;
}

.new-table-box .head-item{
    font-weight: bold;
}
    
.new-table-box .child-item{
    background-color: #f4f4f4;font-style: italic;
}

/* Section amount */
.new-table-box .section .amount{
    text-align:right;
    font-weight:bold;
}

/* Total column */
.new-table-box .total{
    /* font-weight:bold; */
}

/* Grand total row */
.new-table-box .grand{
    background:#dfe5f1;
    font-weight:bold;
    font-size:16px;
}

.new-table-box .grand td{
    padding:14px;
}
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);